export default __webpack_public_path__ + "static/media/text.a6dac3b7.svg";